export const SHOW_SAVE_TO_FOLDER = 'SHOW_SAVE_TO_FOLDER';
export const SHOW_SAVE_ITEM = 'SAVE_ITEM_SHOW';

export const CALLOUT_KEYS = {
    SAVE_TO_FOLDER: 'saveToFolder',
    SAVE_ITEM: 'saveItem',
};

export const STORAGE_KEYS = {
    SAVE_TO_FOLDER: 'favoriteCallout',
    SAVE_ITEM: 'favoriteCallout',
};

export const PRIORITIES = {
    SAVE_TO_FOLDER: 230,
    SAVE_ITEM: 245,
    PREVENT_ON_FIRST_VISIT_PRIORITY: 340, // Has to be lower than multiple PDP visits and higher than callouts priority.
};
